import React from 'react';
import * as AlertDialog from '@radix-ui/react-alert-dialog';

type Props = React.PropsWithChildren;

export const Button: React.FC<Props> = (props) => {
  return <AlertDialog.Action asChild>{props.children}</AlertDialog.Action>;
};
